module.exports = __webpack_public_path__ + "static/media/sara-mastrantonio.dad842cb.jpg";